import classNames from 'classnames';
import React from 'react';
import styles from './index.module.scss';

interface Props {
  children: React.ReactNode;
  className?: string;
  onClick?(): void;
}

export const Button = (props: Props) => {
  const { children, className, onClick } = props;

  const classname = classNames(className, styles.button);

  return (
    <button
      className={classname}
      onClick={() => {
        onClick?.();
      }}
    >
      {children}
    </button>
  );
};
